export default {
  criterionUsageTitle: {
    id: 'finder_criterion_usage_title',
    defaultMessage: 'What will you use it for?',
  },
  criterionBudgetTitle: {
    id: 'finder_criterion_budget_title',
    defaultMessage: 'What’s your budget?',
  },
  criterionSizeTitle: {
    id: 'finder_criterion_size_title',
    defaultMessage: 'What size do you want?',
  },
  criterionConditionTitle: {
    id: 'finder_criterion_condition_title',
    defaultMessage: 'Which conditions?',
  },
  criterionRequirementsTitle: {
    id: 'finder_criterion_requirements_title',
    defaultMessage: 'More requirements?',
  },
} as const
